import React from 'react';
import { Space, Typography } from 'antd';
import { Themes, useTheme } from '@maxtropy/components';

type AuthBannerProps = {
  title: string;
  statistic?: number;
  logoUrl: string;
};

export default function AuthBanner({ title, statistic, logoUrl }: AuthBannerProps) {
  const theme = useTheme();
  return (
    <Space align="center">
      <img src={logoUrl} alt="" style={{ width: 69 }} />
      <Space direction="vertical">
        <Typography.Text>{title}</Typography.Text>
        <Typography.Title level={3} style={{ color: theme === Themes.DARK ? '#52E7FF' : '#4A90E2' }}>
          {statistic ?? '--'}
        </Typography.Title>
      </Space>
    </Space>
  );
}
